import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isSameDay, isWeekend } from 'date-fns';

export class DateValidators {
  static minDate(minDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null || control.value === '' || !minDate) {
        return null;
      }

      if (control.value < minDate) {
        return { minDate: true };
      }

      return null;
    };
  }

  static maxDate(maxDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null || control.value === '' || !maxDate) {
        return null;
      }

      if (control.value > maxDate) {
        return { maxDate: true };
      }

      return null;
    };
  }

  static blackoutDates(blackoutDates: Date[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null || control.value === '' || !blackoutDates) {
        return null;
      }

      const dateValue = new Date(control.value);
      if (blackoutDates.some((x) => isSameDay(x, dateValue))) {
        return { blackoutDate: true };
      }

      return null;
    };
  }

  static cutOffDate(date: Date, achCutOffDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (
        control.value == null ||
        control.value === '' ||
        !achCutOffDate ||
        !date
      ) {
        return null;
      }

      let isInValidCutOff = false;
      const dateValue = new Date(control.value);
      if (isSameDay(achCutOffDate, dateValue)) {
        isInValidCutOff = date.getTime() > achCutOffDate.getTime();
      }

      if (isInValidCutOff && control.value) {
        return { blackoutDate: true };
      }

      return null;
    };
  }

  static noWeekends(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null || control.value === '') {
        return null;
      }

      const dateValue = new Date(control.value);
      if (isWeekend(dateValue)) {
        return { weekend: true };
      }

      return null;
    };
  }
}
